module.exports = __webpack_public_path__ + "img/top.a76a1100.png";